// extracted by mini-css-extract-plugin
export default {"container":"LoadingElement2_container__zjUSq","loadingElement":"LoadingElement2_loadingElement__9LCmK","loadingElementAnimation":"LoadingElement2_loadingElementAnimation__deIad"};